import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { StoxlyClient } from '@stoxly/api-client';

/** Boards (copilot chat v2 Part 4): a thread's materialized boards + version history. */
export function createChatbotBoardsQueries(client: StoxlyClient) {
  return createQueryKeys('chatbotBoards', {
    // ['chatbotBoards', 'list', threadId]
    list: (threadId: string) => ({
      queryKey: [threadId],
      queryFn: ({ signal }) => client.chatbotBoardsListBoards({ params: { id: threadId }, signal }),
    }),

    // ['chatbotBoards', 'board', threadId, boardId] (+ ?version via the caller)
    board: (threadId: string, boardId: string, version?: number) => ({
      queryKey: [threadId, boardId, version ?? 'latest'],
      queryFn: ({ signal }) =>
        client.chatbotBoardsGetBoard({
          params: { id: threadId, boardId },
          queries: version === undefined ? {} : { version },
          signal,
        }),
    }),

    // ['chatbotBoards', 'versions', threadId, boardId]
    versions: (threadId: string, boardId: string) => ({
      queryKey: [threadId, boardId],
      queryFn: ({ signal }) =>
        client.chatbotBoardsListVersions({ params: { id: threadId, boardId }, signal }),
    }),
  });
}

export function createChatbotBoardsMutations(client: StoxlyClient) {
  return {
    // Restore APPENDS a new version (history stays immutable).
    restoreVersion: {
      mutationFn: (vars: { threadId: string; boardId: string; version: number }) =>
        client.chatbotBoardsRestoreVersion(undefined, {
          params: { id: vars.threadId, boardId: vars.boardId, version: vars.version },
        }),
    },
  };
}
